import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import NavProduct from '../comps/NavProduct';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import styles from './index.module.scss';
import ProductContent from './ProductContent';
import TabSupport from '../comps/TabSupport';
import TabSpecs from '../comps/TabSpecs';

const theme = 'white';
const tabList = ['Product', 'Support', 'Specs'];

export default function Detail() {
    const { productTabActive, pageStatus } = useProductStore();
    const dispatch = useProductDispatch();
    const { query } = useRouter();
    const tabName: string = (query.tab as string) || '';
    const [showNav, setShowNav] = useState(pageStatus !== 'statusA');

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [dispatch, tabName]);

    useEffect(() => {
        setShowNav(pageStatus !== 'statusA');
    }, [pageStatus]);

    return (
        <div className={styles.detail}>
            {showNav && <NavProduct />}
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent />
            </div>
            {productTabActive === 'Support' && (
                <div className="product-item-tab product-item-tab-active">
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className="product-item-tab product-item-tab-active">
                    <TabSpecs theme={theme} />
                </div>
            )}
        </div>
    );
}
